// // // // import React, { useState, useContext, useEffect, useRef } from 'react'
// // // // import { useLocation,useNavigate, Link } from 'react-router-dom';
// // // // import LogoImage from '../assets/puraorgaicLogoDemo.png'
// // // // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // // // import { faHeart, faUser } from '@fortawesome/free-regular-svg-icons';
// // // // import { faCartShopping, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
// // // // import { StoreContext } from '../Context/StoreContext';
// // // // import { StoreContextType } from '../Context/types';
// // // // import { LoginPopUP } from '../LoginPopup/LoginPopUP';

// // // // const HeaderFinal = () => {
// // // //     const location = useLocation();
// // // //     const { cartItems ,setToken } = useContext(StoreContext) as StoreContextType;
// // // //     const [isLoginPopUpOpen, setIsLoginPopUpOpen] = useState(false);
// // // //     const navigate = useNavigate();

// // // //   const handleLoginClick = () => {
// // // //     setIsLoginPopUpOpen(true);  // Open the login popup when the Login link is clicked
// // // //   };
// // // //     const token = localStorage.getItem("token")

// // // //     // State to handle the user menu dropdown toggle
// // // //     const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

// // // //     // Ref to detect clicks outside the user dropdown
// // // //     const userMenuRef = useRef<HTMLDivElement>(null);

// // // //     // Function to toggle the dropdown visibility
// // // //     const handleUserIconClick = () => {
// // // //         setIsUserMenuOpen(prevState => !prevState);
// // // //     }

// // // //     const handleLogout =()=>{
// // // //         localStorage.removeItem("token")
// // // //         setToken("")
// // // //         setIsUserMenuOpen(false)
// // // //         navigate("/")
// // // //     }
// // // //     // Close the dropdown if clicked outside
// // // //     const handleClickOutside = (event: MouseEvent) => {
// // // //         if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
// // // //             setIsUserMenuOpen(false);
// // // //         }
// // // //     }

// // // //     // Attach the click outside event listener
// // // //     useEffect(() => {
// // // //         document.addEventListener('mousedown', handleClickOutside);
// // // //         return () => {
// // // //             document.removeEventListener('mousedown', handleClickOutside);
// // // //         };
// // // //     }, []);

// // // //     return (
// // // //         <>
// // // //             {/* pt-8 */}
// // // //             <nav className='md:flex hidden bg-white pl-8 pr-8 shadow-xl w-full justify-between items-center z-20'>
// // // //                 <div className='flex justify-between w-1/4'>
// // // //                     <img src={LogoImage} alt='logo' width='160px' />
// // // //                 </div>
// // // //                 <div className='flex justify-around w-1/2'>
// // // //                     <Link className={`block p-4 ${location.pathname === '/' ? 'text-orange-300' : ''}`} to="/">
// // // //                         Home
// // // //                     </Link>
// // // //                     <Link className={`block p-4 ${location.pathname === '/about' ? 'text-orange-300' : ''}`} to="/about">
// // // //                         About
// // // //                     </Link>
// // // //                     <Link className={`block p-4 ${location.pathname === '/product' ? 'text-orange-300' : ''}`} to="/product">
// // // //                         Products
// // // //                     </Link>
// // // //                     <Link className={`block p-4 ${location.pathname === '/contact' ? 'text-orange-300' : ''}`} to="/contact">
// // // //                         Contact
// // // //                     </Link>
// // // //                 </div>
// // // //                 <div className='w-1/4 flex justify-around items-center'>
// // // //                     <FontAwesomeIcon icon={faMagnifyingGlass} />
// // // //                     <FontAwesomeIcon icon={faHeart} />
// // // //                     <Link to="/cart">
// // // //                         <div className='relative'>
// // // //                             <FontAwesomeIcon icon={faCartShopping} />
// // // //                             {Object.keys(cartItems).length === 0 ? "" : <sup className='text-base text-green-800 absolute left-3 -top-3'>
// // // //                                 <div>{Object.keys(cartItems).length}</div>
// // // //                             </sup>}
// // // //                         </div>
// // // //                     </Link>
// // // //                     <div className="relative" ref={userMenuRef}>
// // // //                         {/* User icon that toggles the dropdown */}
// // // //                         <FontAwesomeIcon
// // // //                             icon={faUser}
// // // //                             onClick={handleUserIconClick}
// // // //                             className="cursor-pointer"
// // // //                         />
// // // //                         {isUserMenuOpen && (
// // // //                             <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md">
// // // //                                 <ul className="text-sm">
// // // //                                     {token ? <>
// // // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // // //                                             <Link to="/profile" onClick={()=>setIsUserMenuOpen(false)}>My Profile</Link>
// // // //                                         </li>
// // // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // // //                                             <Link to="/myorders" onClick={()=>setIsUserMenuOpen(false)}>Orders</Link>
// // // //                                         </li>
// // // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // // //                                             <Link to="" onClick={handleLogout}>Logout</Link>
// // // //                                         </li></> : <>
// // // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // // //                                         <button onClick={handleLoginClick}>Login</button>
// // // //                                         </li>
// // // //                                     </>}
// // // //                                 </ul>
// // // //                             </div>
// // // //                         )}
// // // //                     </div>
// // // //                 </div>
// // // //                 {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
// // // //             </nav>
// // // //         </>
// // // //     );
// // // // }

// // // // export default HeaderFinal;


// // // import React, { useState, useContext, useEffect, useRef } from 'react'
// // // import { useLocation, useNavigate, Link } from 'react-router-dom';
// // // import LogoImage from '../assets/puraorgaicLogoDemo.png'
// // // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // // import { faHeart, faUser, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
// // // import { faCartShopping, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
// // // import { StoreContext } from '../Context/StoreContext';
// // // import { StoreContextType } from '../Context/types';
// // // import { LoginPopUP } from '../LoginPopup/LoginPopUP';

// // // const HeaderFinal = () => {
// // //     const location = useLocation();
// // //     const { cartItems, setToken } = useContext(StoreContext) as StoreContextType;
// // //     const [isLoginPopUpOpen, setIsLoginPopUpOpen] = useState(false);
// // //     const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// // //     const navigate = useNavigate();

// // //     const handleLoginClick = () => {
// // //         setIsLoginPopUpOpen(true);
// // //     };

// // //     const token = localStorage.getItem("token");
// // //     const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
// // //     const [isUserMenuOpenDesktop, setIsUserMenuOpenDesktop] = useState(false);
// // //     const [isUserDesktopMenuOpen, setIsUserDesktopMenuOpen] = useState(false);
// // //     const userMenuRef = useRef<HTMLDivElement>(null);
// // //     const mobileMenuRef = useRef<HTMLDivElement>(null);

// // //     const handleUserIconClick = () => {
// // //         setIsUserMenuOpen(prevState => !prevState);
// // //     };
// // //     const handleUserDesktopIconClick = () => {
// // //         setIsUserDesktopMenuOpen(prevState => !prevState);
// // //     };

// // //     const handleLogout = () => {
// // //         localStorage.removeItem("token");
// // //         setToken("");
// // //         setIsUserMenuOpen(false);
// // //         navigate("/");
// // //     };

// // //     const toggleMobileMenu = () => {
// // //         setIsMobileMenuOpen(!isMobileMenuOpen);
// // //     };

// // //     // Close dropdowns when clicked outside
// // //     const handleClickOutside = (event: MouseEvent) => {
// // //         if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
// // //             setIsUserMenuOpen(false);
// // //         }
// // //         if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node) && 
// // //             !(event.target as HTMLElement).closest('.mobile-menu-button')) {
// // //             setIsMobileMenuOpen(false);
// // //         }
// // //     };

// // //     useEffect(() => {
// // //         document.addEventListener('mousedown', handleClickOutside);
// // //         return () => {
// // //             document.removeEventListener('mousedown', handleClickOutside);
// // //         };
// // //     }, []);

// // //     // Close mobile menu when route changes
// // //     useEffect(() => {
// // //         setIsMobileMenuOpen(false);
// // //     }, [location]);

// // //     return (
// // //         <>
// // //             {/* Desktop Navigation */}
// // //             <nav className='hidden md:flex bg-white pl-8 pr-8 shadow-xl w-full justify-between items-center z-20 sticky top-0'>
// // //                 <div className='flex justify-between w-1/4'>
// // //                     <img src={LogoImage} alt='logo' width='160px' />
// // //                 </div>
// // //                 <div className='flex justify-around w-1/2'>
// // //                     <Link className={`block p-4 ${location.pathname === '/' ? 'text-orange-300' : ''}`} to="/">
// // //                         Home
// // //                     </Link>
// // //                     <Link className={`block p-4 ${location.pathname === '/about' ? 'text-orange-300' : ''}`} to="/about">
// // //                         About
// // //                     </Link>
// // //                     <Link className={`block p-4 ${location.pathname === '/product' ? 'text-orange-300' : ''}`} to="/product">
// // //                         Products
// // //                     </Link>
// // //                     <Link className={`block p-4 ${location.pathname === '/contact' ? 'text-orange-300' : ''}`} to="/contact">
// // //                         Contact
// // //                     </Link>
// // //                 </div>
// // //                 <div className='w-1/4 flex justify-around items-center'>
// // //                     <FontAwesomeIcon icon={faMagnifyingGlass} className="hover:text-orange-300 cursor-pointer" />
// // //                     <FontAwesomeIcon icon={faHeart} className="hover:text-orange-300 cursor-pointer" />
// // //                     <Link to="/cart">
// // //                         <div className='relative hover:text-orange-300'>
// // //                             <FontAwesomeIcon icon={faCartShopping} />
// // //                             {Object.keys(cartItems).length === 0 ? "" : <sup className='text-base text-green-800 absolute left-3 -top-3'>
// // //                                 <div>{Object.keys(cartItems).length}</div>
// // //                             </sup>}
// // //                         </div>
// // //                     </Link>
// // //                     <div className="relative" ref={userMenuRef}>
// // //                         <FontAwesomeIcon
// // //                             icon={faUser}
// // //                             onClick={handleUserDesktopIconClick}
// // //                             className="cursor-pointer hover:text-orange-300"
// // //                         />
// // //                         {isUserMenuOpenDesktop && (
// // //                             <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md z-30">
// // //                                 <ul className="text-sm">
// // //                                     {token ? <>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <Link to="/profile" onClick={() => setIsUserDesktopMenuOpen(false)}>My Profile</Link>
// // //                                         </li>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <Link to="/myorders" onClick={() => setIsUserDesktopMenuOpen(false)}>Orders</Link>
// // //                                         </li>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <Link to="" onClick={handleLogout}>Logout</Link>
// // //                                         </li></> : <>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <button onClick={handleLoginClick}>Login</button>
// // //                                         </li>
// // //                                     </>}
// // //                                 </ul>
// // //                             </div>
// // //                         )}
// // //                     </div>
// // //                 </div>
// // //                 {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
// // //             </nav>

// // //             {/* Mobile Navigation */}
// // //             <nav className='md:hidden flex bg-white p-4 shadow-xl w-full justify-between items-center z-20 sticky top-0'>
// // //                 <div className='flex items-center'>
// // //                     <button 
// // //                         className="mobile-menu-button mr-4 text-xl"
// // //                         onClick={toggleMobileMenu}
// // //                     >
// // //                         <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
// // //                     </button>
// // //                     <img src={LogoImage} alt='logo' width='120px' />
// // //                 </div>

// // //                 <div className='flex items-center space-x-4'>
// // //                     <Link to="/cart" className="relative">
// // //                         <FontAwesomeIcon icon={faCartShopping} className="text-lg" />
// // //                         {Object.keys(cartItems).length === 0 ? "" : 
// // //                             <sup className='text-xs text-green-800 absolute -top-2 -right-2 bg-orange-100 rounded-full h-5 w-5 flex items-center justify-center'>
// // //                                 {Object.keys(cartItems).length}
// // //                             </sup>
// // //                         }
// // //                     </Link>
// // //                     <div className="relative" ref={mobileMenuRef}>
// // //                         <FontAwesomeIcon
// // //                             icon={faUser}
// // //                             onClick={handleUserIconClick}
// // //                             className="cursor-pointer text-lg"
// // //                         />
// // //                         {isUserMenuOpen && (
// // //                             <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md z-30">
// // //                                 <ul className="text-sm">
// // //                                     {token ? <>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <Link to="/profile" onClick={() => setIsUserMenuOpen(false)}>My Profile</Link>
// // //                                         </li>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <Link to="/myorders" onClick={() => setIsUserMenuOpen(false)}>Orders</Link>
// // //                                         </li>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <Link to="" onClick={handleLogout}>Logout</Link>
// // //                                         </li></> : <>
// // //                                         <li className="p-2 hover:bg-gray-100 cursor-pointer">
// // //                                             <button onClick={handleLoginClick}>Login</button>
// // //                                         </li>
// // //                                     </>}
// // //                                 </ul>
// // //                             </div>
// // //                         )}
// // //                     </div>
// // //                 </div>
// // //             </nav>

// // //             {/* Mobile Sidebar Menu */}
// // //             {isMobileMenuOpen && (
// // //                 <div 
// // //                     ref={mobileMenuRef}
// // //                     className="md:hidden fixed inset-0 z-10 bg-black bg-opacity-50"
// // //                     onClick={() => setIsMobileMenuOpen(false)}
// // //                 >
// // //                     <div 
// // //                         className="w-4/5 max-w-xs h-full bg-white shadow-lg transform transition-transform duration-300 ease-in-out"
// // //                         onClick={(e) => e.stopPropagation()}
// // //                     >
// // //                         <div className="p-4 border-b flex justify-between items-center">
// // //                             <img src={LogoImage} alt='logo' width='120px' />
// // //                             <button onClick={() => setIsMobileMenuOpen(false)}>
// // //                                 <FontAwesomeIcon icon={faTimes} className="text-gray-500" />
// // //                             </button>
// // //                         </div>
// // //                         <div className="p-4">
// // //                             <ul className="space-y-4">
// // //                                 <li>
// // //                                     <Link 
// // //                                         to="/" 
// // //                                         className={`block p-3 rounded-md ${location.pathname === '/' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}
// // //                                     >
// // //                                         Home
// // //                                     </Link>
// // //                                 </li>
// // //                                 <li>
// // //                                     <Link 
// // //                                         to="/about" 
// // //                                         className={`block p-3 rounded-md ${location.pathname === '/about' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}
// // //                                     >
// // //                                         About
// // //                                     </Link>
// // //                                 </li>
// // //                                 <li>
// // //                                     <Link 
// // //                                         to="/product" 
// // //                                         className={`block p-3 rounded-md ${location.pathname === '/product' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}
// // //                                     >
// // //                                         Products
// // //                                     </Link>
// // //                                 </li>
// // //                                 <li>
// // //                                     <Link 
// // //                                         to="/contact" 
// // //                                         className={`block p-3 rounded-md ${location.pathname === '/contact' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}
// // //                                     >
// // //                                         Contact
// // //                                     </Link>
// // //                                 </li>
// // //                                 <li className="pt-4 border-t">
// // //                                     <div className="flex space-x-4 p-3">
// // //                                         <FontAwesomeIcon icon={faMagnifyingGlass} className="text-lg hover:text-orange-300" />
// // //                                         <FontAwesomeIcon icon={faHeart} className="text-lg hover:text-orange-300" />
// // //                                     </div>
// // //                                 </li>
// // //                                 {!token && (
// // //                                     <li>
// // //                                         <button 
// // //                                             onClick={handleLoginClick}
// // //                                             className="w-full text-left p-3 rounded-md hover:bg-gray-100"
// // //                                         >
// // //                                             Login
// // //                                         </button>
// // //                                     </li>
// // //                                 )}
// // //                             </ul>
// // //                         </div>
// // //                     </div>
// // //                 </div>
// // //             )}

// // //             {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
// // //         </>
// // //     );
// // // }

// // // export default HeaderFinal;

import React, { useState, useContext, useEffect, useRef } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import LogoImage from '../assets/puraorgaicLogoDemo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faUser, faBars, faTimes, faCartShopping, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { StoreContext } from '../Context/StoreContext';
import { StoreContextType, Product } from '../Context/types';
import { LoginPopUP } from '../LoginPopup/LoginPopUP';

const HeaderFinal = () => {
    const location = useLocation();
    const { cartItems, setToken, food_list, token } = useContext(StoreContext) as StoreContextType;
    const [isLoginPopUpOpen, setIsLoginPopUpOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isUserMenuOpenDesktop, setIsUserMenuOpenDesktop] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState<Product[]>([]);
    const [showSearchResults, setShowSearchResults] = useState(false);

    const navigate = useNavigate();
    const userMenuRef = useRef<HTMLDivElement>(null);
    const mobileMenuRef = useRef<HTMLDivElement>(null);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const searchResultsRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const skipAutoLoginPopupRoutes = ['/login', '/register'];
        const hasShownLoginPopup = localStorage.getItem('hasShownLoginPopup') === 'true';

        if (!token && !hasShownLoginPopup && !skipAutoLoginPopupRoutes.includes(location.pathname)) {
            setIsLoginPopUpOpen(true);
            localStorage.setItem('hasShownLoginPopup', 'true');
        }
    }, [token, location.pathname]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            localStorage.removeItem('hasShownLoginPopup');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const handleLoginClick = () => {
        setIsLoginPopUpOpen(true);
    };

    const handleRegisterClick = () => {
        navigate('/register');
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        setToken('');
        setIsUserMenuOpen(false);
        setIsUserMenuOpenDesktop(false);
        navigate('/');
    };

    const handleUserIconClick = () => {
        setIsUserMenuOpen(prevState => !prevState);
    };

    const handleUserDesktopIconClick = () => {
        setIsUserMenuOpenDesktop(prevState => !prevState);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
        if (!isSearchOpen) {
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 100);
        } else {
            setSearchQuery('');
            setShowSearchResults(false);
        }
    };

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setSearchQuery(query);

        if (query.trim() === '') {
            setShowSearchResults(false);
            return;
        }

        const results = food_list?.filter((food) => {
            return (
                food.title.toLowerCase().includes(query.toLowerCase()) ||
                food.description?.toLowerCase().includes(query.toLowerCase()) ||
                food.ingredients?.toLowerCase().includes(query.toLowerCase()) ||
                food.benefits?.toLowerCase().includes(query.toLowerCase()) ||
                food.tags?.toLowerCase().includes(query.toLowerCase())
            );
        }) || [];

        setSearchResults(results);
        setShowSearchResults(true);
    };

    const handleProductClick = (productId: string) => {
        setIsSearchOpen(false);
        setSearchQuery('');
        setShowSearchResults(false);
        navigate(`/product/${productId}`);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
            setIsUserMenuOpenDesktop(false);
        }
        if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
            setIsMobileMenuOpen(false);
        }
        if (searchResultsRef.current && !searchResultsRef.current.contains(event.target as Node) &&
            !(event.target as HTMLElement).closest('.search-container')) {
            setShowSearchResults(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setIsMobileMenuOpen(false);
        setIsSearchOpen(false);
        setSearchQuery('');
        setShowSearchResults(false);
    }, [location]);

    return (
        <>
            {/* Desktop Navigation */}
            <nav className='hidden md:flex pl-8 py-[10px] pr-8 bg-white shadow-xl w-full justify-between items-center rounded-b-3xl z-50 sticky top-0'>
                <div className='flex justify-between w-2/4'>
                    <Link to="/">
                        <img src={LogoImage} alt='logo' width='190px' />
                    </Link>
                </div>
                <div className='flex justify-around w-1/2'>
                    <Link className={`block p-4 font-semibold ${location.pathname === '/' ? 'text-orange-300' : ''}`} to="/">Home</Link>
                    <Link className={`block p-4 font-semibold ${location.pathname === '/about' ? 'text-orange-300' : ''}`} to="/about">About</Link>
                    <Link className={`block p-4 font-semibold ${location.pathname === '/shop' ? 'text-orange-300' : ''}`} to="/shop">Shop</Link>
                    <Link className={`block p-4 font-semibold ${location.pathname === '/blogs' ? 'text-orange-300' : ''}`} to="/blogs">Blogs</Link>
                    <Link className={`block p-4 font-semibold ${location.pathname === '/contact' ? 'text-orange-300' : ''}`} to="/contact">Contact</Link>
                </div>
                <div className='w-1/4 flex justify-center items-center gap-2 md:gap-6'>

                    {/* <FontAwesomeIcon icon={faMagnifyingGlass} className="hover:text-orange-300 cursor-pointer" /> */}
                    <Link to='/wishlist'><FontAwesomeIcon icon={faHeart} className="hover:text-orange-300 text-2xl cursor-pointer" /></Link>
                    <Link to="/cart">
                        <div className='relative  hover:text-orange-300'>
                            <FontAwesomeIcon icon={faCartShopping} className='text-2xl' />
                            {Object.keys(cartItems).length > 0 && <sup className='text-base text-[#1B6392] border-[#1B6392] absolute left-3 bg-gray-400 rounded-full border px-2 -top-3'>
                                <div>{Object.keys(cartItems).length}</div>
                            </sup>}
                        </div>
                    </Link>
                    <div className="relative" ref={userMenuRef}>
                        <FontAwesomeIcon
                            icon={faUser}
                            onClick={handleUserDesktopIconClick}
                            className="cursor-pointer text-2xl hover:text-orange-300"
                        />
                        {isUserMenuOpenDesktop && (
                            <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md z-30">
                                <ul className="text-sm">
                                    {token ? <>
                                        <Link to="/profile" onClick={() => setIsUserMenuOpenDesktop(false)}>
                                            <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                                My Profile
                                            </li>
                                        </Link>
                                        <Link to="/myorders" onClick={() => setIsUserMenuOpenDesktop(false)}>
                                            <li className="p-2 hover:bg-gray-100 cursor-pointer">

                                                Orders
                                            </li>
                                        </Link>
                                        <Link to="" onClick={handleLogout}>
                                            <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                                Logout
                                            </li>
                                        </Link>
                                    </> : <>
                                        <Link to="" onClick={handleLoginClick}>
                                            <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                                Login
                                            </li>
                                        </Link>
                                    </>}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
                {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
            </nav>

            {/* Mobile Navigation */}
            <nav className='md:hidden flex bg-white p-4 shadow-xl w-full justify-between items-center z-20 sticky top-0'>
                <div className='flex items-center'>
                    {!isMobileMenuOpen && <button
                        className="mobile-menu-button mr-4 text-xl"
                        onClick={toggleMobileMenu}
                    >
                        <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
                    </button>}
                    {isMobileMenuOpen && <button
                        className="mobile-menu-button mr-4 text-xl"
                        onClick={toggleMobileMenu}
                    >
                        <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
                    </button>}
                    <img src={LogoImage} alt='logo' width='120px' />
                </div>
                <div className='flex items-center space-x-4'>
                    <Link to="/cart" className="relative">
                        <FontAwesomeIcon icon={faCartShopping} className="text-lg" />
                        {Object.keys(cartItems).length > 0 && <sup className='text-xs text-green-800 absolute -top-2 -right-2 bg-orange-100 rounded-full h-5 w-5 flex items-center justify-center'>
                            {Object.keys(cartItems).length}
                        </sup>}
                    </Link>
                    <div className="relative" ref={mobileMenuRef}>
                        <FontAwesomeIcon
                            icon={faUser}
                            onClick={handleUserIconClick}
                            className="cursor-pointer text-lg"
                        />
                        {isUserMenuOpen && (
                            <div className="absolute right-0 mt-2 w-40 bg-white border shadow-lg rounded-md z-30">
                                <ul className="text-sm">
                                    {token ? <>
                                        <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                            <Link to="/profile" onClick={() => setIsUserMenuOpen(false)}>My Profile</Link>
                                        </li>
                                        <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                            <Link to="/myorders" onClick={() => setIsUserMenuOpen(false)}>Orders</Link>
                                        </li>
                                        <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                            <Link to="" onClick={handleLogout}>Logout</Link>
                                        </li></> : <>
                                        <li className="p-2 hover:bg-gray-100 cursor-pointer">
                                            <button onClick={handleLoginClick}>Login</button>
                                        </li>
                                    </>}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </nav>

            {/* Mobile Sidebar Menu */}
            {isMobileMenuOpen && (
                <div
                    ref={mobileMenuRef}
                    className="md:hidden fixed inset-0 z-10 bg-black bg-opacity-50"
                    onClick={() => setIsMobileMenuOpen(false)}
                >
                    <div
                        className="w-4/5 max-w-xs h-full bg-white shadow-lg transform transition-transform duration-300 ease-in-out"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="p-4 border-b flex justify-between items-center">
                            <img src={LogoImage} alt='logo' width='120px' />
                            <button onClick={() => setIsMobileMenuOpen(false)}>
                                <FontAwesomeIcon icon={faTimes} className="text-gray-500" />
                            </button>
                        </div>
                        <div className="p-4">
                            <ul className="space-y-4">
                                <li>
                                    <Link to="/" className={`block p-3 rounded-md ${location.pathname === '/' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}>
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/about" className={`block p-3 rounded-md ${location.pathname === '/about' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}>
                                        About
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/shop" className={`block p-3 rounded-md ${location.pathname === '/product' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}>
                                        Shop
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blogs" className={`block p-3 rounded-md ${location.pathname === '/product' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}>
                                        Blogs
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact" className={`block p-3 rounded-md ${location.pathname === '/contact' ? 'bg-orange-100 text-orange-500' : 'hover:bg-gray-100'}`}>
                                        Contact
                                    </Link>
                                </li>
                                <li className="pt-4 border-t">
                                    <div className="flex space-x-4 p-3">
                                        <FontAwesomeIcon icon={faMagnifyingGlass} className="text-lg hover:text-orange-300" />
                                        <FontAwesomeIcon icon={faHeart} className="text-lg hover:text-orange-300" />
                                    </div>
                                </li>
                                {!token && (
                                    <li>
                                        <button onClick={handleLoginClick} className="w-full text-left p-3 rounded-md hover:bg-gray-100">
                                            Login
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
        </>
    );
}

export default HeaderFinal;


// import React, { useState, useContext, useEffect, useRef, ChangeEvent } from 'react';
// import { useLocation, useNavigate, Link } from 'react-router-dom';
// import LogoImage from '../assets/puraorgaicLogoDemo.png';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faHeart, faUser, faBars, faTimes, faCartShopping, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
// import { StoreContext } from '../Context/StoreContext';
// import { StoreContextType, Product } from '../Context/types';
// import { LoginPopUP } from '../LoginPopup/LoginPopUP';

// const HeaderFinal = () => {
//   const location = useLocation();
//   const { cartItems, setToken, food_list, token } = useContext(StoreContext) as StoreContextType;
//   const [isLoginPopUpOpen, setIsLoginPopUpOpen] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
//   const [isUserMenuOpenDesktop, setIsUserMenuOpenDesktop] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [searchResults, setSearchResults] = useState<Product[]>([]);
//   const [showSearchResults, setShowSearchResults] = useState(false);

//   const navigate = useNavigate();
//   const userMenuRef = useRef<HTMLDivElement>(null);
//   const mobileMenuRef = useRef<HTMLDivElement>(null);
//   const searchInputRef = useRef<HTMLInputElement>(null);
//   const searchResultsRef = useRef<HTMLDivElement>(null);

//   const handleLoginClick = () => {
//     setIsLoginPopUpOpen(true);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     setToken('');
//     setIsUserMenuOpen(false);
//     setIsUserMenuOpenDesktop(false);
//     navigate('/');
//   };

//   const handleUserIconClick = () => {
//     setIsUserMenuOpen(prevState => !prevState);
//   };

//   const handleUserDesktopIconClick = () => {
//     setIsUserMenuOpenDesktop(prevState => !prevState);
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };

//   const toggleSearch = () => {
//     setIsSearchOpen(!isSearchOpen);
//     if (!isSearchOpen) {
//       setTimeout(() => {
//         searchInputRef.current?.focus();
//       }, 100);
//     } else {
//       setSearchQuery('');
//       setShowSearchResults(false);
//     }
//   };

//   const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
//     const query = e.target.value;
//     setSearchQuery(query);

//     if (query.trim() === '') {
//       setShowSearchResults(false);
//       return;
//     }

//     // Filter foodList based on search query
//     const results = food_list?.filter((food) => {
//       return (
//         food.title.toLowerCase().includes(query.toLowerCase()) ||
//         food.description?.toLowerCase().includes(query.toLowerCase()) ||
//         food.ingredients?.toLowerCase().includes(query.toLowerCase()) ||
//         food.benefits?.toLowerCase().includes(query.toLowerCase()) ||
//         food.tags?.toLowerCase().includes(query.toLowerCase())
//       );
//     }) || [];

//     setSearchResults(results);
//     setShowSearchResults(true);
//   };

//   const handleProductClick = (productId: string) => {
//     setIsSearchOpen(false);
//     setSearchQuery('');
//     setShowSearchResults(false);
//     navigate(`/product/${productId}`);
//   };

//   const handleClickOutside = (event: MouseEvent) => {
//     if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
//       setIsUserMenuOpenDesktop(false);
//     }
//     if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
//       setIsMobileMenuOpen(false);
//     }
//     if (searchResultsRef.current && !searchResultsRef.current.contains(event.target as Node) &&
//       !(event.target as HTMLElement).closest('.search-container')) {
//       setShowSearchResults(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // Close mobile menu when route changes
//   useEffect(() => {
//     setIsMobileMenuOpen(false);
//     setIsSearchOpen(false);
//     setSearchQuery('');
//     setShowSearchResults(false);
//   }, [location]);

//   return (
//     <>
//       {/* Desktop Navigation */}
//       <nav className='hidden md:flex bg-white pl-8 pr-8 shadow-xl w-full justify-between items-center z-20 sticky top-0'>
//         <div className='flex justify-between w-1/4'>
//           <img src={LogoImage} alt='logo' width='160px' />
//         </div>
//         <div className='flex justify-around w-1/2'>
//           <Link className={`block p-4 ${location.pathname === '/' ? 'text-orange-300' : ''}`} to="/">Home</Link>
//           <Link className={`block p-4 ${location.pathname === '/about' ? 'text-orange-300' : ''}`} to="/about">About</Link>
//           <Link className={`block p-4 ${location.pathname === '/product' ? 'text-orange-300' : ''}`} to="/product">Products</Link>
//           <Link className={`block p-4 ${location.pathname === '/contact' ? 'text-orange-300' : ''}`} to="/contact">Contact</Link>
//         </div>
//         <div className='w-1/4 flex justify-around items-center'>
//           <div className="relative search-container">
//             {isSearchOpen ? (
//               <div className="absolute right-0 top- flex items-center bg-white border rounded-lg overflow-hidden" style={{ width: '240px' }}>
//                 <input
//                   ref={searchInputRef}
//                   type="text"
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="w-full px-3 py-2 focus:outline-none"
//                   placeholder="Search products..."
//                 />
//                 <button onClick={toggleSearch} className="px-3 text-gray-500">
//                   <FontAwesomeIcon icon={faXmark} />
//                 </button>
//               </div>
//             ) : (
//               <FontAwesomeIcon
//                 icon={faMagnifyingGlass}
//                 onClick={toggleSearch}
//                 className="hover:text-orange-300 cursor-pointer"
//               />
//             )}

//             {/* Search Results Dropdown */}
//             {showSearchResults && searchResults.length > 0 && (
//               <div
//                 ref={searchResultsRef}
//                 className="absolute right-0 mt-8 w-64 bg-white border shadow-lg rounded-md z-30 max-h-96 overflow-y-auto"
//               >
//                 <ul className="divide-y divide-gray-100">
//                   {searchResults.map((product) => (
//                     <Link to={`/menu/product/${product.id}`}>
//                     <li
//                       key={product.id}
//                       className="p-3 hover:bg-gray-50 cursor-pointer flex items-center"
//                       onClick={() => handleProductClick(product.id.toString())}
//                     >
//                       {product.images[0]?.src && (
//                         <img
//                           src={product.images[0].src}
//                           alt={product.title}
//                           className="w-10 h-10 object-cover mr-3 rounded"
//                         />
//                       )}
//                       <div>
//                         <div className="font-medium">{product.title}</div>
//                         <div className="text-sm text-gray-500">₹{product.variants?.[0]?.price}</div>
//                       </div>
//                     </li>
//                     </Link>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {showSearchResults && searchResults.length === 0 && searchQuery.trim() !== '' && (
//               <div
//                 ref={searchResultsRef}
//                 className="absolute right-0 mt-1 w-64 bg-white border shadow-lg rounded-md z-30 p-4 text-center"
//               >
//                 No products found matching "{searchQuery}"
//               </div>
//             )}
//           </div>
//           <FontAwesomeIcon icon={faHeart} className="hover:text-orange-300 cursor-pointer" />
//           <Link to="/cart">
//             <div className='relative hover:text-orange-300'>
//               <FontAwesomeIcon icon={faCartShopping} />
//               {Object.keys(cartItems).length > 0 && <sup className='text-base text-green-800 absolute left-3 -top-3'>
//                 <div>{Object.keys(cartItems).length}</div>
//               </sup>}
//             </div>
//           </Link>
//           <div className="relative" ref={userMenuRef}>
//             <FontAwesomeIcon
//               icon={faUser}
//               onClick={handleUserDesktopIconClick}
//               className="cursor-pointer hover:text-orange-300"
//             />
//             {isUserMenuOpenDesktop && (
//               <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md border p-2">
//                 {token ? (
//                   <>
//                     <div className="p-2 text-sm hover:bg-gray-100 cursor-pointer" onClick={handleLogout}>Logout</div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="p-2 text-sm hover:bg-gray-100 cursor-pointer" onClick={handleLoginClick}>Login</div>
//                     <Link to="/signup" className="block p-2 text-sm hover:bg-gray-100">Sign Up</Link>
//                   </>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </nav>

//       {/* Mobile Navigation */}
//       <div className={`md:hidden fixed top-0 left-0 z-50 w-full h-full bg-gray-900 bg-opacity-50 ${isMobileMenuOpen ? 'block' : 'hidden'}`} onClick={toggleMobileMenu}></div>
//       <nav ref={mobileMenuRef} className={`md:hidden fixed top-0 left-0 z-50 w-4/5 h-full bg-white shadow-lg transform ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform`}>
//         <div className='flex justify-between items-center p-4'>
//           <img src={LogoImage} alt='logo' width='120px' />
//           <FontAwesomeIcon icon={faTimes} onClick={toggleMobileMenu} className="text-2xl cursor-pointer" />
//         </div>
//         <div className="flex flex-col items-start p-4">
//           <Link to="/" className="py-2">Home</Link>
//           <Link to="/about" className="py-2">About</Link>
//           <Link to="/product" className="py-2">Products</Link>
//           <Link to="/contact" className="py-2">Contact</Link>
//           <div className="py-2">
//             <FontAwesomeIcon icon={faMagnifyingGlass} onClick={toggleSearch} className="cursor-pointer text-xl" />
//           </div>
//         </div>
//       </nav>

//       {/* Login Popup */}
//       {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
//     </>
//   );
// };

// export default HeaderFinal;


// const HeaderFinal = () => {
//   const location = useLocation();
//   const { cartItems, setToken, food_list, token } = useContext(StoreContext) as StoreContextType;
//   const [isLoginPopUpOpen, setIsLoginPopUpOpen] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
//   const [isUserMenuOpenDesktop, setIsUserMenuOpenDesktop] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [searchResults, setSearchResults] = useState<Product[]>([]);
//   const [showSearchResults, setShowSearchResults] = useState(false);
// const [showComingSoon, setShowComingSoon] = useState(false);

//   const handleHeartClick = () => {
//     setShowComingSoon(true);
//     setTimeout(() => {
//       setShowComingSoon(false); // Hide the message after 3 seconds
//     }, 3000);
//   };
//   const navigate = useNavigate();
//   const userMenuRef = useRef<HTMLDivElement>(null);
//   const mobileMenuRef = useRef<HTMLDivElement>(null);
//   const searchInputRef = useRef<HTMLInputElement>(null);
//   const searchResultsRef = useRef<HTMLDivElement>(null);

//   const handleLoginClick = () => {
//     setIsLoginPopUpOpen(true);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     setToken('');
//     setIsUserMenuOpen(false);
//     setIsUserMenuOpenDesktop(false);
//     navigate('/');
//   };

//   const handleUserIconClick = () => {
//     setIsUserMenuOpen(prevState => !prevState);
//   };

//   const handleUserDesktopIconClick = () => {
//     setIsUserMenuOpenDesktop(prevState => !prevState);
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };

//   const toggleSearch = () => {
//     setIsSearchOpen(!isSearchOpen);
//     if (!isSearchOpen) {
//       setTimeout(() => {
//         searchInputRef.current?.focus();
//       }, 100);
//     } else {
//       setSearchQuery('');
//       setShowSearchResults(false);
//     }
//   };

//   const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
//     const query = e.target.value;
//     setSearchQuery(query);

//     if (query.trim() === '') {
//       setShowSearchResults(false);
//       return;
//     }

//     const results = food_list?.filter((food) => {
//       return (
//         food.title.toLowerCase().includes(query.toLowerCase()) ||
//         food.description?.toLowerCase().includes(query.toLowerCase()) ||
//         food.ingredients?.toLowerCase().includes(query.toLowerCase()) ||
//         food.benefits?.toLowerCase().includes(query.toLowerCase()) ||
//         food.tags?.toLowerCase().includes(query.toLowerCase())
//       );
//     }) || [];

//     setSearchResults(results);
//     setShowSearchResults(true);
//   };

//   const handleProductClick = (productId: string) => {
//     setIsSearchOpen(false);
//     setSearchQuery('');
//     setShowSearchResults(false);
//     navigate(`/product/${productId}`);
//   };

//   const handleClickOutside = (event: MouseEvent) => {
//     if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
//       setIsUserMenuOpenDesktop(false);
//     }
//     if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
//       setIsMobileMenuOpen(false);
//     }
//     if (searchResultsRef.current && !searchResultsRef.current.contains(event.target as Node) &&
//       !(event.target as HTMLElement).closest('.search-container')) {
//       setShowSearchResults(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     setIsMobileMenuOpen(false);
//     setIsSearchOpen(false);
//     setSearchQuery('');
//     setShowSearchResults(false);
//   }, [location]);

//   return (
//     <>
//       {/* Desktop Navigation */}
//       <nav className='hidden md:flex bg-white pl-8 pr-8 shadow-xl w-full justify-between items-center z-20 sticky top-0'>
//         <div className='flex justify-between w-1/4'>
//           <img src={LogoImage} alt='logo' width='160px' />
//         </div>
//         <div className='flex justify-around w-1/2'>
//           <Link className={`block p-4 ${location.pathname === '/' ? 'text-orange-300' : ''}`} to="/">Home</Link>
//           <Link className={`block p-4 ${location.pathname === '/about' ? 'text-orange-300' : ''}`} to="/about">About</Link>
//           <Link className={`block p-4 ${location.pathname === '/product' ? 'text-orange-300' : ''}`} to="/product">Products</Link>
//           <Link className={`block p-4 ${location.pathname === '/contact' ? 'text-orange-300' : ''}`} to="/contact">Contact</Link>
//         </div>
//         <div className='w-1/4 flex justify-around items-center'>
//           <div className="relative search-container">
//             {/* {isSearchOpen ? (
//               <div className="absolute right-0 top-10 flex items-center bg-white border rounded-lg overflow-hidden" style={{ width: '240px' }}>
//                 <input
//                   ref={searchInputRef}
//                   type="text"
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="w-full px-3 py-2 focus:outline-none"
//                   placeholder="Search products..."
//                 />
//                 <button onClick={toggleSearch} className="px-3 text-gray-500">
//                   <FontAwesomeIcon icon={faXmark} />
//                 </button>
//               </div>
//             ) : (
//               <FontAwesomeIcon
//                 icon={faMagnifyingGlass}
//                 onClick={toggleSearch}
//                 className={`hover:text-orange-300 cursor-pointer transition-colors ${isSearchOpen ? 'text-orange-300' : 'text-gray-700'}`}
//               />
//             )} */}.
//             <FontAwesomeIcon
//               icon={faMagnifyingGlass}
//               onClick={toggleSearch}
//               className={`cursor-pointer transition-all duration-300 ${isSearchOpen ? 'text-orange-300' : 'text-gray-700'}`}
//             />
//             <div className={`absolute right-0 top-10 transition-all duration-300 ${isSearchOpen ? 'opacity-100' : 'opacity-0'}`}>
//               <input
//                 ref={searchInputRef}
//                 type="text"
//                 value={searchQuery}
//                 onChange={handleSearch}
//                 className="w-64 px-3 py-2 focus:outline-none border rounded-lg"
//                 placeholder="Search products..."
//               />
//             </div>
// {/* 
// {isSearchOpen ? (
//               <div className="absolute right-0 top-0 flex items-center bg-white border rounded-lg overflow-hidden shadow-md transition-all duration-200" style={{ width: '280px' }}>
//                 <div className="px-3 py-2">
//                   <FontAwesomeIcon 
//                     icon={faMagnifyingGlass} 
//                     className="text-orange-300" 
//                   />
//                 </div>
//                 <input
//                   ref={searchInputRef}
//                   type="text"
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="w-full py-2 focus:outline-none"
//                   placeholder="Search products..."
//                 />
//                 <button onClick={toggleSearch} className="px-3 text-gray-500 hover:text-orange-300">
//                   <FontAwesomeIcon icon={faXmark} />
//                 </button>
//               </div>
//             ) : (
//               <FontAwesomeIcon
//                 icon={faMagnifyingGlass}
//                 onClick={toggleSearch}
//                 className="hover:text-orange-300 cursor-pointer"
//               />
//             )} */}
//             {/* Search Results Dropdown */}
//             {showSearchResults && searchResults.length > 0 && (
//               <div
//                 ref={searchResultsRef}
//                 className="absolute right-0 mt-8 w-64 top-10 bg-white border shadow-lg rounded-md z-30 max-h-96 overflow-y-auto"
//               >
//                 <ul className="divide-y divide-gray-100">
//                   {searchResults.map((product) => (
//                     <Link to={`/menu/product/${product.id}`} key={product.id}>
//                       <li
//                         className="p-3 hover:bg-gray-50 cursor-pointer flex items-center"
//                         onClick={() => handleProductClick(product.id.toString())}
//                       >
//                         {product.images[0]?.src && (
//                           <img
//                             src={product.images[0].src}
//                             alt={product.title}
//                             className="w-10 h-10 object-cover mr-3 rounded"
//                           />
//                         )}
//                         <div>
//                           <div className="font-medium">{product.title}</div>
//                           <div className="text-sm text-gray-500">₹{product.variants?.[0]?.price}</div>
//                         </div>
//                       </li>
//                     </Link>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {showSearchResults && searchResults.length === 0 && searchQuery.trim() !== '' && (
//               <div
//                 ref={searchResultsRef}
//                 className="absolute right-0 mt-1 w-64 bg-white border shadow-lg rounded-md z-30 p-4 text-center"
//               >
//                 No products found matching "{searchQuery}"
//               </div>
//             )}
//           </div>
//           <FontAwesomeIcon icon={faHeart} className="hover:text-orange-300 cursor-pointer"  onClick={handleHeartClick} />
//           {showComingSoon && (
//           <div className="absolute top-20 px-4 py-2 right-2  bg-gray-800 text-white text-center py-2 rounded-md shadow-md">
//             Coming Soon!
//           </div>
//         )}
//           <Link to="/cart">
//             <div className='relative hover:text-orange-300'>
//               <FontAwesomeIcon icon={faCartShopping} />
//               {Object.keys(cartItems).length > 0 && <sup className='text-base text-green-800 absolute left-3 -top-3'>
//                 <div>{Object.keys(cartItems).length}</div>
//               </sup>}
//             </div>
//           </Link>
//           <div className="relative" ref={userMenuRef}>
//             <FontAwesomeIcon
//               icon={faUser}
//               onClick={handleUserDesktopIconClick}
//               className="cursor-pointer hover:text-orange-300"
//             />
//             {isUserMenuOpenDesktop && (
//               <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md border p-2">
//                 {token ? (
//                   <>
//                     <div className="p-2 text-sm hover:bg-gray-100 cursor-pointer" onClick={handleLogout}>Logout</div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="p-2 text-sm hover:bg-gray-100 cursor-pointer" onClick={handleLoginClick}>Login</div>
//                     <Link to="/signup" className="block p-2 text-sm hover:bg-gray-100">Sign Up</Link>
//                   </>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </nav>

//       {/* Mobile Navigation */}
//       <div className={`md:hidden fixed top-0 left-0 z-50 w-full h-full bg-gray-900 bg-opacity-50 ${isMobileMenuOpen ? 'block' : 'hidden'}`} onClick={toggleMobileMenu}></div>
//       <nav ref={mobileMenuRef} className={`md:hidden fixed top-0 left-0 z-50 w-4/5 h-full bg-white shadow-lg transform ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform`}>
//         <div className='flex justify-between items-center p-4'>
//           <img src={LogoImage} alt='logo' width='120px' />
//           <FontAwesomeIcon icon={faTimes} onClick={toggleMobileMenu} className="text-2xl cursor-pointer" />
//         </div>
//         <div className="flex flex-col items-start p-4">
//           <Link to="/" className="py-2">Home</Link>
//           <Link to="/about" className="py-2">About</Link>
//           <Link to="/product" className="py-2">Products</Link>
//           <Link to="/contact" className="py-2">Contact</Link>
//           <div className="py-2">
//             <FontAwesomeIcon icon={faMagnifyingGlass} onClick={toggleSearch} className="cursor-pointer text-xl" />
//           </div>
//         </div>
//       </nav>

//       {/* Login Popup */}
//       {isLoginPopUpOpen && <LoginPopUP setShowLogin={setIsLoginPopUpOpen} />}
//     </>
//   );
// };

// export default HeaderFinal;